import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "content-section" }
const _hoisted_2 = {
  key: 0,
  class: "card card-feat"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
      /*#__PURE__*/_createElementVNode("h1", { class: "h2 mb-3 text-center" }, " Du har ingen aktiv bolåneansökan ")
    ])
  ])
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", { class: "h2 mb-3 text-center" }, "Välkommen till Ordna Bolån", -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = { class: "mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MortgageCalculationView = _resolveComponent("MortgageCalculationView")!
  const _component_MortgageTopMenu = _resolveComponent("MortgageTopMenu")!
  const _component_StatusProgress = _resolveComponent("StatusProgress")!
  const _component_StatusCard = _resolveComponent("StatusCard")!
  const _component_Feedback = _resolveComponent("Feedback")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.app.loanAmount)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_ctx.app.showMortgageCalculationForCanceledApp)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createVNode(_component_MortgageCalculationView, { app: _ctx.app }, null, 8, ["app"])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_MortgageTopMenu, {
              showFoundProperty: _ctx.app.purpose == 'PromissoryLetter' || _ctx.app.findProperty,
              showMortgageCalculator: _ctx.app.showMortgageCalculationForActiveApp,
              active: "Startsida"
            }, null, 8, ["showFoundProperty", "showMortgageCalculator"]),
            (_ctx.app.loanAmount)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_StatusProgress, { app: _ctx.app }, null, 8, ["app"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_StatusCard, { app: _ctx.app }, null, 8, ["app"])
                  ]),
                  _createElementVNode("div", null, [
                    (_ctx.app.NoContactStatus == 0)
                      ? (_openBlock(), _createBlock(_component_Feedback, { key: 0 }))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
  ]))
}